module.exports = __webpack_public_path__ + "static/media/zaiton-plus-logo.d7171c13.jpg";